export enum MedReviewConfigKey {
  'RELATED_TASK_TEMPLATES' = 'RELATED_TASK_TEMPLATES',
}

export interface MedReviewConfig {
  id: number;
  key: MedReviewConfigKey;
  value: string;
}
